export const makeLeagueUrl = (id: string) => {
  return `https://app.musicleague.com/l/${id}`;
};

export const makeRoundUrl = (leagueId: string, roundId: string) => {
  return `${makeLeagueUrl(leagueId)}/${roundId}`;
};

export const parseUserSlug = (pathUsername: string) => {
  const username = decodeURIComponent(pathUsername).toLowerCase();
  return username;
};

export const makeUserSlug = (username: string) => {
  return encodeURIComponent(username.replaceAll(/[\[\]]/g, '').toLowerCase()).replaceAll('%20', '+');
};

export const makeUserUrl = (username: string) => {
  return `/u/${makeUserSlug(username)}`;
};
